export const CODEKICKBOT_SUPPORT_EMAIL = "codekickbot@gmail.com";
